import React, { useState, useEffect } from 'react';
import { fetchMessages } from '../../api';

export default function ViewMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMessages();
  }, []);

  const loadMessages = async () => {
    try {
      const data = await fetchMessages();
      setMessages(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-8 text-[#f1edfd]">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h1 className="text-2xl lg:text-3xl font-Poppins font-bold">Contact Messages</h1>
        <button 
          onClick={loadMessages}
          className="w-full sm:w-auto text-[#3aa1ff] hover:text-[#288ce6] font-medium text-sm border border-[#3aa1ff] px-4 py-2 rounded-lg hover:bg-[#3aa1ff]/10 transition-colors text-center"
        >
          Refresh
        </button>
      </div>

      <div className="bg-[#1a1a1c] border border-gray-800 rounded-2xl overflow-hidden">
        {loading ? (
          <div className="text-gray-400 text-center py-10">Loading messages...</div>
        ) : messages.length === 0 ? (
          <div className="text-gray-400 text-center py-10 flex flex-col items-center gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-12 h-12 text-gray-700">
              <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
            </svg>
            <p>No messages received yet.</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-800">
            {messages.map(msg => (
              <div key={msg.id} className="p-6 hover:bg-white/5 transition-colors">
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <h3 className="font-bold text-lg">{msg.name}</h3>
                    <a href={`mailto:${msg.email}`} className="text-[#3aa1ff] hover:underline text-sm">{msg.email}</a>
                  </div>
                  <span className="text-gray-500 text-xs">
                    {new Date(msg.createdAt).toLocaleString()}
                  </span>
                </div>
                <div className="mt-4 bg-[#131315] p-4 rounded-lg border border-gray-800 text-gray-300 whitespace-pre-wrap font-Inter text-sm leading-relaxed">
                  {msg.message}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
